/* header-announcement-bar-marquee */
initMarquee('.header-announcement-bar-marquee', {
    mobile: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "right"
    },
    desktop: {
        duration: 100000,
        gap: 0,
        duplicated: true,
        direction: "right"
    }
});
/* header-announcement-bar-marquee */